import { AuraResponseBlocks } from '@/types/models/AuraResponseBlocksModel';
import { AuraFilters } from '@/types/models/AuraFiltersModel';

export interface AuraMessage {
    id: number;
    conversationId: number;
    role?: 'user' | 'assistant' | 'system';
    type: 'user' | 'aura' | 'system' | 'error';
    content: string;
    question?: string;
    response?: AuraResponseBlocks;
    filters?: AuraFilters;
    filtersJson?: AuraFilters;
    metadata?: {
        processingTime: number;
        tokensUsed: number;
        model: string;
    };
    createdAt: string;
}
